import { useState, useRef } from "react";

import api from "@helpers/api";

import "./styles.css";

import CustomModal from "@components/CustomModal";

import { Input } from "@fragments";

function normalizeCode(code) {
  return (code || "")
    .trim()
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]/g, "");
}

function stateFromPreFill(preFill) {
  return {
    id: preFill?.id ?? null,
    community: preFill?.community,
    code: preFill?.code ?? "",
    percent_off: preFill?.percent_off ?? "",
  };
}

/** Default duration until the product exposes duration in the UI. */
const DEFAULT_CREATE_DURATION = { type: "forever", months: null };

export default function ManageCouponModal({ modalRef }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const REF_config = useRef({});
  const REF_callback = useRef();

  const [coupon, setCoupon] = useState({});

  modalRef.current = {
    open(preFill, callback) {
      const base = stateFromPreFill(preFill || {});
      if (!base.community && preFill?.community) {
        base.community = preFill.community;
      }
      REF_config.current = base;
      REF_callback.current = callback;
      setCoupon({ ...REF_config.current });
      setOpen(true);
    },
  };

  async function handleSubmit() {
    if (REF_config.current.id) {
      setOpen(false);
      return;
    }

    const communityId = REF_config.current.community;
    const normalized = normalizeCode(REF_config.current.code);
    const pct = parseInt(REF_config.current.percent_off, 10);

    if (!communityId || !normalized || !pct || pct < 1 || pct > 100) {
      window.setSnackbar?.("Preencha código e desconto válidos");
      return;
    }

    const payload = {
      duration: DEFAULT_CREATE_DURATION,
      code: normalized,
      percent_off: pct,
      currency: "brl",
    };

    try {
      setLoading(true);
      const res = await api.post(`community/${communityId}/coupon`, payload);

      if (res?.response?.status >= 400) {
        window.setSnackbar?.(
          res?.response?.data?.message || "Não foi possível salvar o cupom"
        );
        return;
      }

      if (res?.data?.id) {
        await REF_callback.current?.(res.data);
        setOpen(false);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  const isExisting = !!coupon?.id;

  return (
    <CustomModal
      maxWidth={360}
      bottomButtonSumbitText={isExisting ? undefined : "Salvar cupom"}
      bottomButtonCancelText={isExisting ? "Fechar" : "Cancelar"}
      handleSubmit={handleSubmit}
      loading={loading}
      title={isExisting ? "Detalhes do cupom" : "Criar cupom"}
      open={open}
      handleClose={() => setOpen(false)}
      bodyComponent={
        open ? (
          <div className="px-4 py-1">
            <div className="mb-1 mt-2">
              <Input.Text
                autoFocus={!isExisting}
                value={coupon?.code || ""}
                disabled={isExisting}
                onInput={(v) => {
                  REF_config.current.code = v;
                }}
                label="Código do cupom"
                className="coupon-code"
                style={{ width: "100%" }}
              />
              <Input.Integer
                disabled={isExisting}
                className="coupon-discount mt-2"
                value={coupon?.percent_off}
                onInput={(v) => {
                  REF_config.current.percent_off = v;
                }}
                min={1}
                max={100}
                label="% de desconto"
              />
            </div>
          </div>
        ) : null
      }
    />
  );
}
